module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "chapter"
    }
  }, [_c('p', {
    staticClass: "white4"
  }), _vm._v(" "), _c('h1', [_c('a', {
    attrs: {
      "id": "page18"
    }
  }), _c('a', {
    attrs: {
      "href": "#/103toc#acookstouroftheland"
    }
  }, [_vm._v("A COOK’S TOUR OF THE LAND")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Morocco is, in a sense, an island, surrounded on the west by the Atlantic Ocean and on the north by the Mediterranean Sea, and on the east and south by the pre-Sahara and Sahara Desert. Within its ample borders, a wide variety of geographical features can be found: mountain ranges, mesas and oases, deserts, river valleys, and fertile coastal fishing grounds. In 1975, Morocco’s landmass expanded greatly—from 172,414 sq mi/446,550 sq km, or slightly bigger than California, to 274,460 sq mi/710,850 sq km—when it annexed the southern Sahara region previously controlled by Spain. The country’s population stands at around 34 million, with a majority living in cities along the northern and central Atlantic coastline, and in Fès and Marrakech. The rest of the country remains largely rural.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Morocco’s history has given cooks the inspiration and tools to develop one of the world’s richest cuisines, and the country’s vast and varied landscape offers all the raw materials needed.")]), _vm._v(" "), _c('div', {
    staticClass: "images",
    attrs: {
      "id": "image17"
    }
  }, [_c('p', {
    staticClass: "center"
  }, [_c('a', {
    attrs: {
      "id": "page19"
    }
  }), _c('img', {
    attrs: {
      "alt": "Morocco",
      "src": "images/map.jpg",
      "width": "100%"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "images",
    attrs: {
      "id": "image18"
    }
  }, [_c('p', {
    staticClass: "center"
  }, [_c('a', {
    attrs: {
      "id": "page20"
    }
  }), _c('img', {
    attrs: {
      "alt": "Morocco",
      "src": "images/img-20a.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "images",
    attrs: {
      "id": "image19"
    }
  }, [_c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "Morocco",
      "src": "images/img-20b.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "images",
    attrs: {
      "id": "image19b"
    }
  }, [_c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "Morocco",
      "src": "images/img-21b.jpg"
    }
  })])]), _vm._v(" "), _c('h3', {
    staticClass: "left"
  }, [_c('span', {
    staticClass: "red"
  }, [_vm._v("TANGER, TÉTOUAN, AND THE NORTHWEST TIP")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("In close proximity to Spain and Europe, and straddling the Atlantic Ocean and the Mediterranean Sea, the northern triangular tip of Morocco is the most hybrid part of the country. Spain lies in sight across the Strait of Gibraltar, just 9 mi/14 km wide at its narrowest. This is Europe and Africa’s meeting point, a place showing Spanish influences—lightly floured and fried "), _c('span', {
    attrs: {
      "href": "#/065chapter50#page158",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("fish and calamari")]), _vm._v(", rice dishes, a love of sweet, smoked paprika—yet still holding a clear North African personality. Cooks might first bathe fish in plenty of zesty charmoula marinade and then stuff it with plump olives and preserved lemons as well as rice.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("At the point of the tip is Tanger, the oldest continually inhabited city in the country. A place of legends and myths, the city retains a heady blend of influences from all those who have controlled it: Phoenicians (who founded the city around 1100 BCE), Romans, Byzantines, Visigoths, Arabs, Portuguese, and British (who were there for a short time in the seventeenth century). Tanger’s status as an international city from the 1920s to the 1950s brought more modern, cosmopolitan influences.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("About 30 mi/48 km south down the Atlantic coast is the Portuguese-built port of Asilah, with its tight, whitewashed seaside medina resplendent in brilliant blue doors and shutters. On weekends, families flock to small restaurants for fresh fish and calamari fried in the light Andalusian style—using just flour and a bit of salt. Platters come with a dish of puréed tomato dipping sauce and stack of fresh bread. Diners eat directly on paper place mats, then fold the picked-clean bones and shells into the place mats and throw them away.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page21"
    }
  }), _vm._v("An hour southeast of Tanger lies Tétouan, whose dense tiers of low, whitewashed houses spread up a valley of orange, almond, and pomegranate orchards from the Mediterranean. The city was largely built in the fifteenth and sixteenth centuries by Muslim and Jewish refugees from Spain. It is known in Arabic as “white dove” and “daughter of Granada.” Tétouanese architecture, mosaic tile work, music, jewelry, and refined cooking are impregnated with Andalusian heritage. You can taste it in the "), _c('span', {
    attrs: {
      "href": "#/070chapter55#page166",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("honeyed onion and raisin tfaya")]), _vm._v(" that tops tagines and couscouses; in "), _c('span', {
    attrs: {
      "href": "#/090chapter73#page205",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("seffa")]), _vm._v(", sweet couscous with raisins and almonds; and in crispy, paper-thin sheets of pastry interspersed with ground almonds, sugar, and cinnamon.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The history of Tétouan has continued to intertwine with that of Spain. In the seventeenth and eighteenth centuries, the city’s strategic location and cultural ties formed a bridge between Morocco and Spain—and Europe. During those prosperous centuries, all of Morocco’s trade to Europe passed through Tétouan. When Morocco became a Protectorate, the Spanish named Tétouan the capital of the section under their control.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Eastern flavors are discernible in Tétouan, too. After Ottoman-ruled Algiers fell into the hands of the French in 1830, Tétouan became home to generations of Algerian immigrants. They brought with them Turkish and Middle Eastern influences in grilling meat and skewers of seasoned, ground "), _c('span', {
    attrs: {
      "href": "#/029chapter18#page94",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("kefta ")]), _vm._v(" directly over embers, in using milk in desserts like the lovely pudding called "), _c('span', {
    attrs: {
      "href": "#/085chapter68#page198",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("m’halbi")]), _vm._v(", and in preparing such favorite sweetmeats as sugarcoated gazelle-horn cookies, baklava, and m’hancha, coiled “serpentine” pastry stuffed with almond paste.")]), _vm._v(" "), _c('div', {
    staticClass: "images",
    attrs: {
      "id": "image21"
    }
  }, [_c('p', {
    staticClass: "center"
  }, [_c('a', {
    attrs: {
      "id": "page22"
    }
  }), _c('img', {
    attrs: {
      "alt": "Morocco",
      "src": "images/img-22.jpg"
    }
  })])]), _vm._v(" "), _c('h3', {
    staticClass: "left"
  }, [_c('a', {
    attrs: {
      "id": "page24"
    }
  }), _c('span', {
    staticClass: "red"
  }, [_vm._v("THE RIF MOUNTAINS")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Beginning east of Tétouan and running 200 mi/320 km along the northern Mediterranean coastline, the Rif Mountains form a protective arc of largely impenetrable limestone and sandstone that crests up sharply from the sea to 8,200 ft/2,500 m. Cedar, cork, holm oak, and pine and a medley of wildflowers coat the hills. Home to the Riffian Berbers, the area is one of the most isolated parts of the country.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("It was here in the fifteenth century that Andalusian refugees built the blue-hued city of Chefchaouen. Due to the city’s isolation, defensive position slotted between two summits, holy status, and rabid antiforeignism that lasted until the 1920s, the area has seemingly changed little, and its strong and distinct identity remains largely preserved. The pine-filled hills around Chefchaouen are dense with olive, almond, plum, and fig orchards, as well as thirty-five varieties of edible wild mushrooms. The rustic cooking of the countryside relies heavily on local herbs, fragrant honeys, and herds of goats whose milk Riffian Berbers make into pungent cheeses and whose meat they stew in "), _c('span', {
    attrs: {
      "href": "#/046chapter33#page122",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("tagines")]), _vm._v(". Few dishes are as homey and hearty as the beloved "), _c('em', [_vm._v("bessara,")]), _vm._v(" a puréed soup of dried and split fava beans or split peas with cumin and paprika and served with a drizzle local "), _c('span', {
    attrs: {
      "href": "#/019chapter9#page77",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("olive oil")]), _vm._v(".")]), _vm._v(" "), _c('h3', {
    staticClass: "left"
  }, [_c('span', {
    staticClass: "red"
  }, [_vm._v("FÈS, MEKNÈs, AND THE MIDDLE ATLAS")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Fès is the country’s oldest Imperial City, its symbolic heart and traditional culinary capital. As a Fassi—a resident of Fès—from one of the city’s noble families proudly told me, “When we talk about Morocco, we talk about Fès.” Founded in the last years of the eighth century by the Arabs, who had swept into Morocco shortly before then, Fès was the religious, trade, and cultural center of the country until the French moved the capital to Rabat in 1912. It was here in this dense, quiet, and often private city—especially compared to the open and lively squares of cities like Marrakech—that the concept of “Morocco” took hold and, by extension, “Moroccan cuisine.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Fès was a crossroads, a stopping point, and even a destination for the great caravans of the past that came from each corner of the country, from Andalucía, the Sahara, the Middle East. The "), _c('em', [_vm._v("souqs")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page27"
    }
  }), _vm._v("of the extensive medieval medina—containing a staggering 9,500 narrow alleys, lanes, and passageways—offer all that even the most discerning cook could possibly desire. Even today, someone coming from elsewhere in Morocco immediately notices the ampleness of choice, the more varieties of flour, of legumes, of honey.")]), _vm._v(" "), _c('div', {
    staticClass: "images",
    attrs: {
      "id": "image22"
    }
  }, [_c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "Morocco",
      "src": "images/img-24.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "images",
    attrs: {
      "id": "image23"
    }
  }, [_c('p', {
    staticClass: "center"
  }, [_c('a', {
    attrs: {
      "id": "page26"
    }
  }), _c('img', {
    attrs: {
      "alt": "Morocco",
      "src": "images/img-26a.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "images",
    attrs: {
      "id": "image24"
    }
  }, [_c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "Morocco",
      "src": "images/img-26b.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "images",
    attrs: {
      "id": "image25"
    }
  }, [_c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "Morocco",
      "src": "images/img-26c.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "images",
    attrs: {
      "id": "image26"
    }
  }, [_c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "Morocco",
      "src": "images/img-8.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    staticClass: "red"
  }, [_vm._v("It’s no surprise, then, that Fassi cooking is generally considered the most sophisticated in Morocco, a product of Arab, Andalusian, and Jewish roots; extreme pride; and abundant local foodstuffs.")])]), _vm._v(" "), _c('div', {
    staticClass: "images",
    attrs: {
      "id": "image27"
    }
  }, [_c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "Morocco",
      "src": "images/img-8.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Influences came, too, from desert oases. These supplied goods, but also cooks and workers, as well. With their valuable water that drew travelers and settlers and also watered date palms, they were a great source of wealth. The culinary arts have long held a place of prestige here. Spices are mixed with particular refinement, the sweet and savory blended with unparalleled sublimity and harmony, and the presentation is exacting.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("A number of Fassi dishes remain particularly memorable: the famous stuffed pastry "), _c('em', [_vm._v("pastilla")]), _vm._v(" with squab or chicken; a “sweet” "), _c('span', {
    attrs: {
      "href": "#/058chapter44#page144",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("tagine")]), _vm._v(" topped with stewed tomatoes caramelized with honey, perfumed with a few delicate drops of orange flower water or rose water, and scattered with toasted almonds and sesame seeds; a savory chicken tagine called "), _c('span', {
    attrs: {
      "href": "#/059chapter45#page147",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("khdra")])]), _vm._v(" with plenty of onions and almonds in the buttery saffron sauce. There is pleasure, too, in the simpler street foods of the medina, including the beloved stuffed spleen ("), _c('em', [_vm._v("tihane")]), _vm._v(" or "), _c('em', [_vm._v("rate farcie")]), _vm._v("), the deep-fried potato fritters called "), _c('span', {
    attrs: {
      "href": "#/023chapter12#page83",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("maakouda")])]), _vm._v(", and the hard spring plums pickled in brine, sold in candy stores and by kids who carry plastic tubs of the plums prepared by their mothers.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Just forty-five minutes west of Fès lies the low-key and overshadowed Imperial City of Meknès. With olive and citrus groves and fields of some of the country’s finest mint surrounding the city, it is no surprise that Meknès has a celebrated covered market filled with neat, geometric displays of preserved olives and lemons and abundant fresh herbs. The land around Meknès is also home to vineyards. The burgeoning wine industry is laid over the foundations of French viticulture from the Protectorate era and, to an extent, the Roman tradition around the nearby ancient city of Volubilis. The largest winemaker is Les Celliers de Meknès, with nearly 5,000 acres/2,000 ha of vineyards.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("To the south of these two cities begins the Middle Atlas, a range pockmarked with volcanic peaks, etched by river gorges, and covered in oak, cork, ash, juniper, and stands of giant cedar trees that reach up to 130 ft/40 m. The northwestern slope of the range irrigates the oranges, lemons, and olives of Meknès, the artichokes and wild cardoon thistles of Fès, and the cherries of Sefrou, while the southern slope carries water to the orchards of apples, apricots, plums, and walnuts around Midelt.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The Berber city of Azrou, the first of the important Middle Atlas towns south from Fès or Meknès, has fruit orchards and honey, and is well known for its trout, which once swam wild in its streams. The French established trout pisciculture in the first half of the twentieth century during the Protectorate and raised the fish in the cool hills away from the heat of the plains. Area cooks prepare the trout in the French-influenced meunière sauce or in their own, distinctive ways—panfried and sprinkled with crushed almonds or, my favorite, stuffed with grated carrots, fresh bay leaves, and plenty of black pepper (see "), _c('span', {
    attrs: {
      "href": "#/068chapter53#page163",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("recipe")]), _vm._v(").")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The lush hills of the Middle Atlas are famous for their fertile grazing land for sheep as well as for their wild herbs, which find their way into teas and infusions, traditional medicines, and many savory dishes. In Azrou, for instance, cooks include fresh mint in their ground meat "), _c('span', {
    attrs: {
      "href": "#/029chapter18#page94",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("kefta")])]), _vm._v(". Another area well known for its herbs is around Taza, the citadel city that guards the Taza Gap between the Middle Atlas and the Rif Mountains and the eastern entrance to Fès.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Farther east, at the reaches of these ranges near the Algerian border, is Oujda, the capital of the Oriental Region, the only city in modern-day Morocco to have been occupied by the Ottomans. Turkish rule lasted from 1727 until the early 1800s.")]), _vm._v(" "), _c('h3', {
    staticClass: "left"
  }, [_c('a', {
    attrs: {
      "id": "page28"
    }
  }), _c('span', {
    staticClass: "red"
  }, [_vm._v("THE ATLANTIC COAST FROM RABAT TO AGADIR AND SOUTH")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Morocco’s Atlantic coast stretches from the fertile, populous north all the way to the dry, sparsely populated south where the Sahara meets the sea.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The northern part holds the cosmopolitan cities of Rabat and Casablanca. The French named Rabat the country’s capital at the beginning of the Protectorate in 1912, and it remained so after independence in 1956. The youngest of Morocco’s four Imperial Cities, Rabat is known to the epicurean for its sweet dishes and dried fruits. "), _c('span', {
    attrs: {
      "href": "#/075chapter59#page180",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Seven Vegetable Couscous")]), _vm._v(" — Morocco’s national dish—and couscous topped with the caramelized onion and raisin "), _c('span', {
    attrs: {
      "href": "#/070chapter55#page166",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("tfaya")])]), _vm._v(" are extremely popular in Rabat as well as in Salé, the capital’s more conservative neighbor just across the mouth of the Bou Regreg River. Salé also has a wonderful lamb dish with coriander seeds called "), _c('span', {
    attrs: {
      "href": "#/044chapter31#page120",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("mkila")])]), _vm._v(" that is as robustly savory as "), _c('em', [_vm._v("tfaya")]), _vm._v(" is sweet.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("An hour to the south is Casablanca, Morocco’s business capital. Although it has grown from a village of 20,000 in 1906 to a heaving metropolis of about 3.5 million today (one-tenth of the country’s population), it remains steeped in tradition. The city offers not only magnificent seafood restaurants along La Corniche, the lovely waterfront promenade, but in many minds bests Rabat in its love for, and skill in preparing, seven vegetable couscous.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("South of Casablanca, the Atlantic coast turns wild and windy, with great sweeps of undeveloped beach and rocky cliffs, along with crashing surf. Punctuating the coastline are a handful of fishing ports protected by centuries-old ramparts—Azemmour, El Jadida, Oualidia, Safi, Essaouira.")]), _vm._v(" "), _c('div', {
    staticClass: "images",
    attrs: {
      "id": "image28"
    }
  }, [_c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "Morocco",
      "height": "100%",
      "src": "images/img-28a.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "images",
    attrs: {
      "id": "image29"
    }
  }, [_c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "Morocco",
      "height": "100%",
      "src": "images/img-28b.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "page29"
    }
  }), _vm._v("The sea swarms with turbot, sole, bream, mackerel, swordfish, blue shark, conger eel, tuna, shrimp, lobster, crab, and even oysters. The last are a specialty of Oualidia, where beds were arranged in the 1950s in a long, thin, sheltered lagoon.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("But it’s a small, silvery fish that dominates Morocco’s fishing industry: the humble "), _c('em', [_vm._v("serdine")]), _vm._v(" (sardine). Morocco is the world’s largest producer and exporter, with fleets based in Safi, El Jadida, Essaouira, Agadir, and Tan Tan Plage (El Ouatia). Plants in Safi process hundreds of thousands of tons of sardines a year, but not all the catch goes into tins. Fresh sardines remain the country’s most popular, and economical, fish. Many families eat them weekly and in a variety of ways—filleted and ground with herbs and spices, rolled into marble-size balls, and stewed in a fragrant tomato sauce (see "), _c('span', {
    attrs: {
      "href": "#/067chapter52#page160",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("recipe")]), _vm._v("); stewed whole with fresh fava beans; cooked in a tagine over a bed of sliced potatoes and plum tomatoes. On the street, "), _c('span', {
    attrs: {
      "href": "#/027chapter16#page91",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("whole sardines")]), _vm._v(" are grilled over embers, or coupled pairs of "), _c('span', {
    attrs: {
      "href": "#/026chapter15#page88",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("butterflied fillets")]), _vm._v(" are rubbed with a garlic and herb paste and then deep-fried.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In Essaouira, where seagulls wheel over the city’s eighteenth-century ramparts, cooks prepare fish tagines, especially conger eel with caramelized onions. "), _c('span', {
    attrs: {
      "href": "#/070chapter55#page166",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Conger")]), _vm._v(" is flavorful, but monkfish is a preferred, though more expensive option. The city has an important heritage from Moroccan Jews, who, at the beginning of the twentieth century, made up perhaps half of the city’s population.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("South of Agadir, the Anti-Atlas erupts, and long stretches of the coast are rocky and inhospitable, broken with cliffs and rolling surf, and hold just a handful of isolated settlements, namely Mirleft and Sidi Ifni. Spain controlled the latter from 1476 to 1542, "), _c('a', {
    attrs: {
      "id": "page32"
    }
  }), _vm._v("calling it Santa Cruz del Mar Pequeño, and again from 1860 until 1969. The buildings feature art deco curves, and the market is full of seafood—sardines, calamari, and, unusually in Morocco, mussels. Mussels are cooked in tagines and also "), _c('span', {
    attrs: {
      "href": "#/063chapter48#page154",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("stewed in a tomato sauce")]), _vm._v(" that is nearly identical to a Spanish "), _c('span', {
    attrs: {
      "href": "#/062chapter47#page153",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("sofrito")])]), _vm._v(", with purely Moroccan additions of cumin and cilantro. Inland, prickly pear cacti coat the hills, and women’s co-ops have begun making marmalade from the fruit.")]), _vm._v(" "), _c('div', {
    staticClass: "images",
    attrs: {
      "id": "image30"
    }
  }, [_c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "Morocco",
      "src": "images/img-29.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "images",
    attrs: {
      "id": "image31"
    }
  }, [_c('p', {
    staticClass: "center"
  }, [_c('a', {
    attrs: {
      "id": "page30"
    }
  }), _c('img', {
    attrs: {
      "alt": "Morocco",
      "src": "images/img-30.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "images",
    attrs: {
      "id": "image32"
    }
  }, [_c('p', {
    staticClass: "center"
  }, [_c('a', {
    attrs: {
      "id": "page31"
    }
  }), _c('img', {
    attrs: {
      "alt": "Morocco",
      "src": "images/img-31.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("From here south through Tan Tan and where the Drâa Valley meets the sea begins the Sahara. Fishermen perch on high cliffs, casting for bream and croaker, and at low tide scramble down to the waterline to collect mussels as well as "), _c('em', [_vm._v("percebes,")]), _vm._v(" goose barnacles with soft black bodies and hard, clawlike shells, for export to Spain.")]), _vm._v(" "), _c('h3', {
    staticClass: "left"
  }, [_c('span', {
    staticClass: "red"
  }, [_vm._v("MARRAKECH AND THE HIGH ATLAS")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("At a strategic transit point on the north side of the High Atlas lies Marrakech, the great Berber city founded in 1070 and capital of several powerful dynasties. Fringed in orange, lemon, and olive groves, infused with dazzling light, it feels overwhelmingly southern. Whereas the color of north is blue—"), _c('em', [_vm._v("zellij")]), _vm._v(" tiles in Tanger and Tétouan, the walls in Chefchaouen, the paint on wooden sardine boats, the sea itself—here the color is pink, which glows warmly on the city walls. About 12 mi/19 km of thick, reddish pink clay ramparts, some 30 ft/9 m high, wrap around Marrakech. Begun in the 1120s, extended over the following centuries, and punctuated by two hundred towers and twenty gates, the walls protect the city’s ancient heart—its medina and "), _c('em', [_vm._v("souqs,")]), _vm._v(" dense neighborhoods, palaces and tombs of ancient rulers, mosques and madrasahs (Qur’anic schools), and iconic square, Djemaa el Fna. Marrakech is Fès’ only real rival as the country’s culinary capital.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Marrakech cooking is rich, spicy but not hot, refined, and diverse. Culinary trademarks include lamb tagines with vegetables and fruits grown in the surrounding Haouz region and heavily spiced with red and black pepper, cumin, turmeric, saffron, and plenty of "), _c('em', [_vm._v("ras el hanout")]), _vm._v(" blended from dozens of ingredients. One succulent Marrakech specialty is "), _c('span', {
    attrs: {
      "href": "#/051chapter38#page129",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("tangia")])]), _vm._v(", named for the two-handled earthen urn used to prepare it. Packed with seasoned beef or lamb, crushed garlic, preserved lemon, and plenty of spices, the pot is sealed with a piece of thick paper and left to cook slowly for a number of hours in the embers of a "), _c('em', [_vm._v("hammam")]), _vm._v(" (steam bath) under the eye of the "), _c('em', [_vm._v("farnachi,")]), _vm._v(" the man who controls the fire.")]), _vm._v(" "), _c('div', {
    staticClass: "images",
    attrs: {
      "id": "image33"
    }
  }, [_c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "Morocco",
      "src": "images/img-8.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    staticClass: "red"
  }, [_vm._v("The city’s rather open character and appetite emerge as dusk falls and hundreds of stalls assemble on Djemaa el Fna among snake charmers, acrobats, and drummers, storytellers, henna painters, and healers from the Sahara hawking ancient aphrodisiac concoctions.")])]), _vm._v(" "), _c('div', {
    staticClass: "images",
    attrs: {
      "id": "image34"
    }
  }, [_c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "Morocco",
      "src": "images/img-8.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Clouds of grill smoke envelope the locals, tourists, Berbers down from the hills, and nomads from the desert who pack the stalls seeking skewers of grilled "), _c('em', [_vm._v("kefta")]), _vm._v(" or cubes of liver enveloped in "), _c('em', [_vm._v("crépine")]), _vm._v(" (white, veiny caul fat); finger-size "), _c('em', [_vm._v("merguez,")]), _vm._v(" spicy lamb sausages; bowls of tripe stew; "), _c('span', {
    attrs: {
      "href": "#/020chapter10#page78",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("soupy lentils")]), _vm._v("; and silky "), _c('span', {
    attrs: {
      "href": "#/017chapter7#page73",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("harira")])]), _vm._v(" soup. "), _c('span', {
    attrs: {
      "href": "#/025chapter14#page85",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Snails")]), _vm._v(" served in a rich, digestive bouillon flavored with more than a dozen herbs and spices, including licorice, orange peel, ginger, cloves, and gunpowder green tea leaves, remain a trademark dish.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Visible to the south and east of the city are the snowcapped peaks of the High Atlas. Stretching some 450 mi/724 km northeast from coastal Agadir toward Algeria, spreading 40 mi/64 km in width, and rising to 13,671 ft/4,167 m, the High Atlas is the grandest of Morocco’s four mountain ranges. These slopes, with their flattop villages made of rocks, rammed earth "), _c('em', [_vm._v("pisé,")]), _vm._v(" and adobe bricks, and their beefy, fortified "), _c('em', [_vm._v("agadirs")]), _vm._v(" (collective granaries), are a Berber heartland.")]), _vm._v(" "), _c('div', {
    staticClass: "images",
    attrs: {
      "id": "image35"
    }
  }, [_c('p', {
    staticClass: "center"
  }, [_c('a', {
    attrs: {
      "id": "page33"
    }
  }), _c('img', {
    attrs: {
      "alt": "Morocco",
      "src": "images/img-33a.jpg",
      "width": "100%"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "images",
    attrs: {
      "id": "image36"
    }
  }, [_c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "Morocco",
      "height": "100%",
      "src": "images/img-33b.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "images",
    attrs: {
      "id": "image37"
    }
  }, [_c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "Morocco",
      "height": "100%",
      "src": "images/img-33c.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "images",
    attrs: {
      "id": "image38"
    }
  }, [_c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "Morocco",
      "src": "images/img-33d.jpg",
      "width": "100%"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "images",
    attrs: {
      "id": "image39"
    }
  }, [_c('p', {
    staticClass: "center"
  }, [_c('a', {
    attrs: {
      "id": "page34"
    }
  }), _c('img', {
    attrs: {
      "alt": "Morocco",
      "src": "images/img-34.jpg",
      "width": "100%"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "images",
    attrs: {
      "id": "image40"
    }
  }, [_c('p', {
    staticClass: "center"
  }, [_c('a', {
    attrs: {
      "id": "page36"
    }
  }), _c('img', {
    attrs: {
      "alt": "Morocco",
      "src": "images/img-36a.jpg",
      "width": "100%"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "images",
    attrs: {
      "id": "image41"
    }
  }, [_c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "Morocco",
      "height": "100%",
      "src": "images/img-36b.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "images",
    attrs: {
      "id": "image42"
    }
  }, [_c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "Morocco",
      "src": "images/img-36c.jpg",
      "width": "100%"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "images",
    attrs: {
      "id": "image43"
    }
  }, [_c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "Morocco",
      "src": "images/img-36d.jpg",
      "width": "100%"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "images",
    attrs: {
      "id": "image44"
    }
  }, [_c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "Morocco",
      "src": "images/img-36e.jpg",
      "width": "100%"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "images",
    attrs: {
      "id": "image45"
    }
  }, [_c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "Morocco",
      "height": "100%",
      "src": "images/img-36f.jpg"
    }
  })])]), _vm._v(" "), _c('h3', {
    staticClass: "left"
  }, [_c('a', {
    attrs: {
      "id": "page37"
    }
  }), _c('span', {
    staticClass: "red"
  }, [_vm._v("CENTRAL MOROCCO AND THE ANTI-ATLAS")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Over the lofty, serpentine passes of the High Atlas, the land drops down, along streams and through terraced fields of barley that shimmer silvery green in spring and early summer, and into the rock-strewn Anti-Atlas range and sub-Sahara. The vast landscape of winnowed valleys opens out, with the occasional mud-and-straw "), _c('em', [_vm._v("ksar")]), _vm._v(" (fortified village) or crenellated towered "), _c('em', [_vm._v("kasbah")]), _vm._v(" (fortified house) blending into the ocher red earth. A handful of narrow rivers spread like veins, and a bright green ribbon of crops runs through the creases of naked hills, offering surprising riches.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("From its headwaters in the High Atlas, the Drâa River drops east toward the desert before making a wide arc southwest, traversing the feet of the Anti-Atlas and then heading across the desert. There, apart from exceptionally wet years, the river dries and seeps into the parched earth in places before reaching the Atlantic just north of the desert port of Tan Tan Plage (El Ouatia). At 700 mi/1,125 km in length, it’s the country’s longest river.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Long before its outlet to the sea, just after it comes out of the mountains, the river gives birth to a fertile 80-mi/130-km riverine oasis, a string of date palm groves and villages from Agdz to past Zagora. The groves are broken by a labyrinth of high, thick earthen walls that shelter small green fields—with wheat or fruit trees (fig, apricot, pomegranate) under the shade of tall palm trees that produce some of the country’s finest dates. Small paths weave through the dizzying maze, and saddled donkeys remain the most useful and common means of carrying the harvested fruit and dates. Important in terms of providing a source of wealth from crops and a strategic location near the trans-Saharan trade routes, the Drâa was the starting point for the Saadian dynasty in controlling Morocco.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("On the north side of the Drâa runs the Dadès Valley. At the town of El Kelâa des M’Gouna begins the so-called Vallée des Roses, a tangle of dry valleys covered in low hedges that, in spring, blossom with small pink roses. These fragrant blossoms are distilled into the ubiquitous "), _c('em', [_vm._v("ma ward")]), _vm._v(" (rose water).")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("To the south of the Drâa, the area of Taliouine on the high Souktana plateau grows saffron, perhaps first brought to Moroccan shores thousands of years ago by Phoenician traders. In autumn, at dawn, whole families work together to harvest the flowers and then remove the precious stigmas. Used in countless dishes for its natural golden coloring and its distinctive flavor, the fragrant, valuable spice even "), _c('span', {
    attrs: {
      "href": "#/094chapter76#page211",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("laces tea")]), _vm._v("—sometimes with fresh mint, sometimes instead of it.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Farther south, beyond the high peaks, and catching the moist sea breezes, the Souss Valley is the land of the leathery, spiny argan tree. Deep-rooted, sprawling, and living for up to a few centuries, the trees bear a greasy, olivelike fruit collected in summer.")]), _vm._v(" "), _c('div', {
    staticClass: "images",
    attrs: {
      "id": "image46"
    }
  }, [_c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "Morocco",
      "src": "images/img-8.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    staticClass: "red"
  }, [_vm._v("Berber women extract the argan kernels, roast them, and then laboriously grind them on a rough stone mortar to extract a sand-colored, nutty-flavored oil that they drizzle over whole-grain bread, salads, and couscous.")])]), _vm._v(" "), _c('div', {
    staticClass: "images",
    attrs: {
      "id": "image47"
    }
  }, [_c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "Morocco",
      "src": "images/img-8.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("They also blend the oil with the area’s dark honey and small, crunchy almonds from the nearby Ameln Valley to make a thick dip called "), _c('span', {
    attrs: {
      "href": "#/086chapter69#page199",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("amlou")])]), _vm._v(", which is eaten with hunks of fresh flatbread for breakfast or a snack.")]), _vm._v(" "), _c('h3', {
    staticClass: "left"
  }, [_c('a', {
    attrs: {
      "id": "page38"
    }
  }), _c('span', {
    staticClass: "red"
  }, [_vm._v("THE SAHARA AND THE DEEP SOUTH")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The eastern part of Morocco edges Algeria and the Sahara. These fringes hold the great oases and strategic trading posts along the ancient trans-Saharan caravan routes—Rissani, Tafilalt, Erfoud, Mhamid, Guelmim, Smara. Their shady palm groves provide sweet dates that are given to guests as a traditional welcome and are eaten as snacks and with fruit at the end of a meal. Dates are also "), _c('span', {
    attrs: {
      "href": "#/082chapter65#page193",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("stuffed "), _c('em', [_vm._v("with")]), _vm._v(" almond paste")]), _vm._v(" and are "), _c('span', {
    attrs: {
      "href": "#/055chapter41#page137",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("stuffed "), _c('em', [_vm._v("into")]), _vm._v(" young pigeons")]), _vm._v(", as well as used to "), _c('span', {
    attrs: {
      "href": "#/090chapter73#page205",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("decorate sweet couscous")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The deep south, bordered by Algeria and Mauritania and by the long seacoast, was for the first seven decades of the twentieth century a Spanish colony. Integrated into Morocco in the mid-1970s, the sparsely populated area is largely made up of a pale, bleak stony desert called "), _c('em', [_vm._v("hamada;")]), _vm._v(" thorny scrubland with patches of ivory, yellowish, and ocher sand; and "), _c('em', [_vm._v("oueds")]), _vm._v(" (dried riverbeds) feathered with isolated tamarisk or acacia trees.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("It is here that the Sahara meets the Atlantic. Inundated salt pans called "), _c('em', [_vm._v("sabkhat")]), _vm._v(" stretch for dozens of miles, glistening white and pink in the desert light. Although there are some coastal dunes, most often the land meets the sea in cliffs where fishermen perch and cast down with long rods into the pounding surf. The waters off Laâyoune and, another 330 mi/530 km farther south, Dakhla have some of the richest fishing beds in the entire region and supply markets not only in Morocco but in Europe and beyond.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The cooking of the deep south differs from that of the rest of the country. The markets have fewer offerings, and dishes tend to have sparser seasoning. Cooks use the meat of dromedary—the iconic one-humped camel—for grilling and stewing, and for grinding and forming into small patties cooked on a grill. The ancient Saturday "), _c('em', [_vm._v("souq")]), _vm._v(" on the outskirts of Guelmim, long famed for its camels, still sells them, though not for transport anymore but for food. So important is camel as a food that the camel "), _c('em', [_vm._v("souq")]), _vm._v(" is a daily event, whereas the general "), _c('em', [_vm._v("souq")]), _vm._v(" takes place only one day each week. The animals graze along the flat scrublands in the distance under the gaze of a lone shepherd. At butchers’ stalls in towns, camel is the most common meat. For many of the region’s traditionally nomadic people—women in their colorful wraps, men in pale turquoise robes detailed with golden thread—camel is one of the three main elements of their diet, along with dates and milk.")]), _vm._v(" "), _c('div', {
    staticClass: "images",
    attrs: {
      "id": "image48"
    }
  }, [_c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "Morocco",
      "src": "images/img-8.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    staticClass: "red"
  }, [_vm._v("And tea! Three small glasses of mint tea—a dark, potent brew here, far from the delicate, aromatic, amber tones of, say, Fès—are drunk at a time, and remain an important tradition.")])]), _vm._v(" "), _c('div', {
    staticClass: "images",
    attrs: {
      "id": "image49"
    }
  }, [_c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "Morocco",
      "src": "images/img-8.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "images",
    attrs: {
      "id": "image50"
    }
  }, [_c('p', {
    staticClass: "center"
  }, [_c('a', {
    attrs: {
      "id": "page39"
    }
  }), _c('img', {
    attrs: {
      "alt": "Morocco",
      "src": "images/img-39a.jpg",
      "width": "100%"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "images",
    attrs: {
      "id": "image51"
    }
  }, [_c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "Morocco",
      "src": "images/img-39b.jpg",
      "width": "100%"
    }
  })])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ccdf0f04","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/007acookstouroftheland.vue
// module id = 75
// module chunks = 0